import StylesLoader from "./StylesLoader";

export default StylesLoader;
